import template from './location.clone.html';
import controller from './location.clone.controller';
import './location.clone.scss';

let locationCloneComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default locationCloneComponent;




// WEBPACK FOOTER //
// ./client/app/components/location/clone/location.clone.component.js